import React, { useMemo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Done } from '@material-ui/icons';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import qs from "qs";
import qs from 'querystring';

import api from '~/services/api';
import { Form } from '@unform/web';
import { parse, format, setSeconds } from 'date-fns';
import { Spinner } from '~/components';
import {
  Input,
  Select,
  ComboboxMultiple,
  DateTime,
  Hidden,
  Autocomplete,
} from '~/components/Form';
import { isEmpty, isArray } from 'lodash';
import { t, number, dataHora, hora, validCharacters } from '~/helpers';
import { TabelaMovimentacao } from '../../../components';
import { MODULO_CUSTOMIZACAO_RUMO } from '~/constants/modules';

export default function SelMovimentacaoPitStop({
  data,
  reference,
  seleciona,
  close,
  cancelarAcao,
  finalizaGravacao,
  alteraTamanho,
}) {
  const [open, setOpen] = React.useState(false);
  // params: {},
  const [show, setShow] = React.useState(false);
  const [movimentacoes, setMovimentacoes] = React.useState([]);
  const [atendeu, setAtendeu] = React.useState('N');
  const [codigousuario, setCodigousuario] = React.useState('');
  const [justificativas, setJustificativas] = React.useState([]);
  const [observacao, setObservacao] = React.useState('');
  const [idatendimento, setIdatendimento] = React.useState(null);
  const [origem, setOrigem] = React.useState(null);
  const [initials, setInitials] = React.useState({});
  const modules = useSelector((state) => state.user.modules);
  const clienteRumo = modules.includes(MODULO_CUSTOMIZACAO_RUMO);
  const [idposto, setIdposto] = useState(null);

  const [atendeugovernador, setAtendeugovernador] = useState('N');
  const [atendeugerador, setAtendeugerador] = useState('N');
  const [atendeucompressor, setAtendeucompressor] = useState('N');

  const [volumegovernador, setVolumegovernador] = useState(0);
  const [volumegerador, setVolumegerador] = useState(0);
  const [volumecompressor, setVolumecompressor] = useState(0);

  useEffect(() => {
    setIdatendimento(data.idatendimento);
    setOrigem(data.origem);
    carregaDados(data.idatendimento, data.origem);
    buscaMovimentacoes(data.idturno, data.idposto, data.idveiculo, data.origem);
    setIdposto(data.idposto);
  }, [data]);

  const optionsAtendimento = useMemo(
    () => [
      { value: 'N', label: t('s.geral.opcoes.nao') },
      { value: 'X', label: t('s.geral.opcoes.na') },
    ],
    []
  );

  const optionsOk = useMemo(
    () => [
      { value: 'S', label: t('s.geral.opcoes.ok') },
      { value: 'N', label: t('s.geral.opcoes.nok') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idbico',
        label: t('s.operacao.abastecimento.idbico'),
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.relatorio.geral.datahorainicio'),
        align: 'left',
        format: (value) => dataHora(value),
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.geral.horafinal'),
        align: 'left',
        format: (value) => hora(value),
      },
      {
        id: 'idveiculo',
        label: t('s.menu.cadastro.veiculo.locomotiva'),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.global.volume'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'encerranteinicialmovimentacao',
        label: t('s.geral.camposistema.encerranteinicialmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'encerrantefinalmovimentacao',
        label: t('s.geral.camposistema.encerrantefinalmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'acao',
        label: t('s.relatorio.auditoria.acaoauditoriasistema'),
        action: [
          {
            label: t('s.geral.botaoconfirmar'),
            botao: Done,
            edicao: 'selecionar',
          },
        ],
      },
    ],
    []
  );

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const buscaMovimentacoes = async (idturno, idposto, idveiculo, origem) => {
    try {
      const url =
        origem === 'A'
          ? `pitstop/abastecimento/${idturno}/${idposto}/${idveiculo}`
          : `pitstop/lubrificacao/${idturno}/${idposto}/${idveiculo}`;
      const { data } = await api.get(url);
      const list = data.movimentacoes.map((movimentacao) => ({
        ...movimentacao,
      }));
      setShow(true);
      setMovimentacoes(list);
      alteraTamanho(list.length > 0 ? 'md' : 'sm');
    } catch (error) {
      toast.error('Erro ao acessar dados');
    }
  };

  const carregaDados = async (idatendimento, origem) => {
    try {
      const url =
        origem === 'A'
          ? `pitstop/abastecimento/${idatendimento}`
          : `pitstop/lubrificacao/${idatendimento}`;
      const { data } = await api.get(url);
      const atendeu =
        origem === 'A'
          ? data.atendeuatendimentoabastecimento
          : data.atendeuatendimentolubrificacao;
      const justificativas = data.justificativas;
      const observacao =
        origem === 'A'
          ? data.observacaoabastecimento
          : data.observacaolubrificacao;
      setAtendeu(atendeu);
      const codigousuario = data.codigousuario;
      // setJustificativas(justificativas);
      // setObservacao(observacao);

      //console.log('dados do atendimento selecionado', data );

      setAtendeugovernador(
        data.atendeugovernadorlubrificacao
          ? data.atendeugovernadorlubrificacao
          : 'N'
      );
      setAtendeugerador(
        data.atendeugeradorlubrificacao ? data.atendeugeradorlubrificacao : 'N'
      );
      setAtendeucompressor(
        data.atendeucompressorlubrificacao
          ? data.atendeucompressorlubrificacao
          : 'N'
      );

      setInitials({
        atendeu: atendeu,
        codigousuario: codigousuario,
        justificativas: justificativas,
        observacao: observacao,

        //Novos campos para atender a regra de negocio de preenchimento de data e hora do atendimento
        datainicioatendimento:
          origem === 'A'
            ? data.datainicioatendimentoabastecimento &&
              data.datainicioatendimentoabastecimento !== 'NULL'
              ? data.datainicioatendimentoabastecimento
              : null
            : data.datainicioatendimentolubrificacao &&
              data.datainicioatendimentolubrificacao !== 'NULL'
            ? data.datainicioatendimentolubrificacao
            : null,
        datafimatendimento:
          origem === 'A'
            ? data.datafimatendimentoabastecimento &&
              data.datafimatendimentoabastecimento !== 'NULL'
              ? data.datafimatendimentoabastecimento
              : null
            : data.datafimatendimentolubrificacao &&
              data.datafimatendimentolubrificacao !== 'NULL'
            ? data.datafimatendimentolubrificacao
            : null,

        atendeugovernador: data.atendeugovernadorlubrificacao
          ? data.atendeugovernadorlubrificacao
          : 'N',
        atendeugerador: data.atendeugeradorlubrificacao
          ? data.atendeugeradorlubrificacao
          : 'N',
        atendeucompressor: data.atendeucompressorlubrificacao
          ? data.atendeucompressorlubrificacao
          : 'N',
        volumegovernador: data.volumegovernadorlubrificacao
          ? data.volumegovernadorlubrificacao
          : 0,
        volumegerador: data.volumegeradorlubrificacao
          ? data.volumegeradorlubrificacao
          : 0,
        volumecompressor: data.volumecompressorlubrificacao
          ? data.volumecompressorlubrificacao
          : 0,
      });
    } catch (error) {
      toast.error('Erro ao acessar dados');
    }
  };

  const handleSelecionaMovimentacao = async (idmovimentacao) => {
    await seleciona(idmovimentacao, origem);
  };

  async function handleSubmit(param) {
    try {
      //console.log('param submit', param);

      const schemaN = Yup.object().shape({
        atendeu: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
        codigousuario: clienteRumo
          ? Yup.string().nullable()
          : Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .max(100, t('s.geral.validacao.valormaximo').replace('%s', 100)),
        justificativas: Yup.array().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        observacao: Yup.string()
          .ensure()
          .nullable()
          .trim()
          .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),
        datainicioatendimento: clienteRumo
          ? Yup.string().nullable()
          : Yup.mixed()
              .transform((value) =>
                value ? parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()) : null
              )
              .required(t('s.geral.validacao.campoobrigatorio')),
        datafimatendimento: clienteRumo
          ? Yup.string().nullable()
          : Yup.mixed()
              .transform((value) =>
                value ? parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()) : null
              )
              .required(t('s.geral.validacao.campoobrigatorio')),
      });

      const schemaX = Yup.object().shape({
        atendeu: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
        codigousuario: clienteRumo
          ? Yup.string().nullable()
          : Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .max(100, t('s.geral.validacao.valormaximo').replace('%s', 100)),
        observacao: Yup.string()
          .ensure()
          .nullable()
          .trim()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),
      });

      const schema = Yup.object().shape({
        atendeu: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
        codigousuario: clienteRumo
          ? Yup.string().nullable()
          : Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .max(100, t('s.geral.validacao.valormaximo').replace('%s', 100)),
      });

      // Função auxiliar de erro (evita repetição)
      function handleError(err) {
        finalizaGravacao();
        // console.log('ERRO COMPLETO:', err);

        // ARRAY (seu caso)
        if (Array.isArray(err)) {
          toast.error(err.join(', '));
          return;
        }

        // YUP
        if (err instanceof Yup.ValidationError) {
          const validationErrors = {};
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });
          reference.current.setErrors(validationErrors);
          return;
        }

        // BACKEND / AXIOS
        const data = err?.response?.data || err?.data || err;

        const mensagem =
          data?.erros?.join(', ') ||
          data?.message ||
          data?.error ||
          err?.message;

        if (mensagem) {
          toast.error(mensagem);
          return;
        }

        // fallback
        toast.error('Erro inesperado');
      }

      if (param.atendeu === 'N') {
        try {
          await schemaN.validate(param, { abortEarly: false });

          const justs = param.justificativas
            ? param.justificativas.join(',')
            : '';
          const obs = param.observacao ? param.observacao : 'NULL';
          const codigousr = param.codigousuario ? param.codigousuario : 'NULL';

          const datainicioatendimento = param.datainicioatendimento
            ? param.datainicioatendimento
            : null;
          const datafimatendimento = param.datafimatendimento
            ? param.datafimatendimento
            : null;

          const atendeugovernador = param.atendeugovernador
            ? param.atendeugovernador
            : null;

          const atendeugerador = param.atendeugerador
            ? param.atendeugerador
            : null;

          const atendeucompressor = param.atendeucompressor
            ? param.atendeucompressor
            : null;

          const volumegovernador = param.volumegovernador
            ? param.volumegovernador
            : null;

          const volumegerador = param.volumegerador
            ? param.volumegerador
            : null;

          const volumecompressor = param.volumecompressor
            ? param.volumecompressor
            : null;

          await gravaMovimentacao(
            idatendimento,
            idposto,
            origem,
            param.atendeu,
            obs,
            justs,
            codigousr,
            datainicioatendimento,
            datafimatendimento,
            atendeugovernador,
            atendeugerador,
            atendeucompressor,
            volumegovernador,
            volumegerador,
            volumecompressor
          );

          close();
          toast.success(t('s.geral.sucessoalteracao'));
        } catch (err) {
          handleError(err);
          return;
        }
      } else if (param.atendeu === 'X') {
        try {
          await schemaX.validate(param, { abortEarly: false });

          const justs = param.justificativas
            ? param.justificativas.join(',')
            : '';
          const obs = param.observacao ? param.observacao : 'NULL';
          const codigousr = param.codigousuario ? param.codigousuario : 'NULL';

          await gravaMovimentacao(
            idatendimento,
            idposto,
            origem,
            param.atendeu,
            obs,
            justs,
            codigousr
          );

          toast.success(t('s.geral.sucessoalteracao'));
        } catch (err) {
          handleError(err);
          return;
        }
      } else {
        try {
          await schema.validate(param, { abortEarly: false });
        } catch (err) {
          handleError(err);
          return;
        }
      }
    } catch (err) {
      await finalizaGravacao();

      if (Array.isArray(err)) {
        toast.error(err.join(', '));
        return;
      }

      if (err && isArray(err)) {
        toast.error(err[0]);
      }

      await cancelarAcao();

      if (err instanceof Yup.ValidationError) {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  const gravaMovimentacao = async (
    idatendimento,
    idposto,
    origem,
    atendeu,
    obs,
    justs,
    codigousr,
    datainicioatendimento,
    datafimatendimento,
    atendeugovernador,
    atendeugerador,
    atendeucompressor,
    volumegovernador,
    volumegerador,
    volumecompressor
  ) => {
    if (clienteRumo) {
      const { data } = await api.put(
        `pitstop/atendimento/movimentacao/${idatendimento}/${idposto}/${origem}/${atendeu}/${obs}/${codigousr}/${justs}`
      );
    } else {
      const { data } = await api.put('pitstop/atendimento/movimentacao', null, {
        params: {
          idatendimento: String(idatendimento),
          idposto: idposto,
          origem,
          atendeu,
          observacao: obs,
          codigousuario: codigousr,
          justificativas: justs,
          datainicioatendimento,
          datafimatendimento,
          atendeugovernador,
          atendeugerador,
          atendeucompressor,
          volumegovernador,
          volumegerador,
          volumecompressor,
        },
        paramsSerializer: (ps) => qs.stringify(ps),
      });
      // const { data } = await api.put("pitstop/atendimento/movimentacao", null, {
      //   params: {
      //     idatendimento: String(idatendimento),
      //     idposto,
      //     origem,
      //     atendeu,
      //     observacao: obs,
      //     codigousuario: codigousr,
      //     justificativas: justs,
      //     datainicioatendimento,
      //     datafimatendimento,
      //     atendeugovernador,
      //     atendeugerador,
      //     atendeucompressor,
      //     volumegovernador,
      //     volumegerador,
      //     volumecompressor
      //   },
      //   paramsSerializer: (params) =>
      //     qs.stringify(params, { arrayFormat: "repeat" })
      // });
      // const { data } = await api.put(
      //   `pitstop/atendimento/movimentacao/${idatendimento}/${idposto}/${origem}/${atendeu}/${obs}/${codigousr}/${justs}/${datainicioatendimento}/${datafimatendimento}`
      // );
    }
    await close();
  };

  async function handleAtendeugovernador(value) {
    await reference.current.setFieldValue('atendeugovernador', value);
    await setAtendeugovernador(value);
  }

  async function handleAtendeugerador(value) {
    await reference.current.setFieldValue('atendeugerador', value);
    await setAtendeugerador(value);
  }

  async function handleAtendeucompressor(value) {
    await reference.current.setFieldValue('atendeucompressor', value);
    await setAtendeucompressor(value);
  }

  return (
    <>
      {isEmpty(initials) ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <>
          {movimentacoes.length > 0 && (
            <TabelaMovimentacao
              title="" // apresenta apenas o titulo da janela
              cells={header}
              data={movimentacoes}
              height="80vh"
              size="small"
              onIconClick={handleSelecionaMovimentacao}
            />
          )}
          {movimentacoes.length === 0 && (
            <Form
              ref={reference}
              initialData={initials}
              onSubmit={handleSubmit}
            >
              <Select
                name="atendeu"
                label={t('s.cadastro.pitstop.atendeuatendimentoareia')}
                options={optionsAtendimento}
                style={{ width: '100%', marginBottom: 10 }}
                getValue={(value) => setAtendeu(value)}
              />
              {clienteRumo === false && (
                <div style={{ width: '100%', marginBottom: 10 }}>
                  <Autocomplete
                    name="codigousuario"
                    label="nomecodigousuario"
                    url="usuarios"
                    unique="codigousuario"
                    title={t('s.operacao.abastecimento.codigousuario')}
                    disableClearable={true}
                    params={{
                      filterusrposto: data?.idposto,
                      edicao: Boolean(initials?.codigousuario),
                    }}
                    disabled={Boolean(
                      initials?.idusuario || initials?.codigousuario
                    )}
                    style={{ width: '100%', marginBottom: 10 }}
                  />
                </div>
              )}
              {atendeu === 'N' && (
                <ComboboxMultiple
                  name="justificativas"
                  label="descricaoobservacao"
                  url="pitstop/justificativa"
                  unique="idobservacaoatendimento"
                  title={t(
                    's.relatorio.alteracaomodooperacional.justificativa'
                  )}
                  params={{
                    wherefield: ['tipoatendimento'],
                    typewherefield: ['EQUALS'],
                    valuewherefield: [origem === 'A' ? '1' : '2'],
                    pesquisalista: ['true'],
                  }}
                  style={{ width: '100%', marginBottom: 15 }}
                />
              )}
              {/* {JSON.stringify(initials)} */}
              {atendeu === 'N' && clienteRumo === false && (
                <>
                  <DateTime
                    label={t('s.geral.opcoes.datahorainicial')}
                    name="datainicioatendimento"
                    serialize={(value) =>
                      value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
                    }
                    time
                    nullable
                    style={{ width: '100%', marginBottom: 15 }}
                    // style={{ marginTop: 8 }}
                    // inputRef={inputRef}
                  />
                  <DateTime
                    label={t('s.geral.opcoes.datahorafinal')}
                    name="datafimatendimento"
                    serialize={(value) =>
                      value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
                    }
                    time
                    nullable
                    style={{ width: '100%', marginBottom: 15 }}
                    // style={{ marginTop: 16 }}
                  />
                </>
              )}

              {origem !== 'A' && atendeu === 'N' && clienteRumo === false ? (
                <>
                  <Select
                    name="atendeugovernador"
                    id="atendeugovernador"
                    label={t(
                      's.cadastro.pitstop.atendeugovernadorlubrificacao'
                    )}
                    options={optionsOk}
                    onChange={({ target }) =>
                      handleAtendeugovernador(target.value)
                    }
                    // defaultValue={antifurtoabastecimento}
                    style={{ marginTop: 8, width: '100%' }}
                    // getValue={(value) => setAntifurtoabastecimento(value)}
                  />

                  {atendeugovernador === 'S' ? (
                    <Input
                      name="volumegovernador"
                      label={t(
                        's.cadastro.pitstop.volumegovernadorlubrificacao'
                      )}
                      type="number"
                      defaultValue={initials.volumegovernador || 0}
                      style={{ marginTop: 8, marginBottom: 12, width: '100%' }}
                    />
                  ) : (
                    <Hidden name="volumegovernador" value="0" />
                  )}

                  <Select
                    name="atendeugerador"
                    id="atendeugerador"
                    label={t('s.cadastro.pitstop.atendeugeradorlubrificacao')}
                    options={optionsOk}
                    onChange={({ target }) =>
                      handleAtendeugerador(target.value)
                    }
                    // defaultValue={chipabastecimento}
                    style={{ marginTop: 12, width: '100%' }}
                    // getValue={(value) => setChipabastecimento(value)}
                  />

                  {atendeugerador === 'S' ? (
                    <Input
                      name="volumegerador"
                      label={t('s.cadastro.pitstop.volumegeradorlubrificacao')}
                      type="number"
                      defaultValue={initials.volumegerador || 0}
                      style={{ marginTop: 10, marginBottom: 12, width: '100%' }}
                    />
                  ) : (
                    <Hidden name="volumegerador" value="0" />
                  )}

                  <Select
                    name="atendeucompressor"
                    id="atendeucompressor"
                    label={t(
                      's.cadastro.pitstop.atendeucompressorlubrificacao'
                    )}
                    options={optionsOk}
                    onChange={({ target }) =>
                      handleAtendeucompressor(target.value)
                    }
                    // defaultValue={visorabastecimento}
                    style={{ marginTop: 12, width: '100%', marginBottom: 10 }}
                    // getValue={(value) => setVisorabastecimento(value)}
                  />

                  {atendeucompressor === 'S' ? (
                    <Input
                      name="volumecompressor"
                      label={t(
                        's.cadastro.pitstop.volumecompressorlubrificacao'
                      )}
                      type="number"
                      defaultValue={initials.volumecompressor || 0}
                      style={{ marginTop: 4, width: '100%', marginBottom: 24 }}
                    />
                  ) : (
                    <Hidden name="volumecompressor" value="0" />
                  )}
                </>
              ) : (
                <>
                  <Hidden name="atendeugovernador" value="" />
                  <Hidden name="atendeugerador" value="" />
                  <Hidden name="atendeucompressor" value="" />

                  <Hidden name="volumegovernador" value="0" />
                  <Hidden name="volumegerador" value="0" />
                  <Hidden name="volumecompressor" value="0" />
                </>
              )}

              <Input
                name="observacao"
                label={t('s.cadastro.pitstop.observacaoatendimento')}
                multiline
                rows={3}
                inputProps={{ maxLength: 500 }}
                style={{ width: '100%' }}
              />
            </Form>
          )}
        </>
      )}
    </>
  );
}
